<template>
    <DxDataGrid :data-source="dsTrepteVechime" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id">
        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="500" :height="465" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxPopup>
            <DxFormGrid :col-count="2">
                <DxItem 
                    data-field="Code" 
                    editor-type="dxTextArea"
                    :editor-options="{ height: 50 }"
                />
                <DxItem 
                    data-field="Order" 
                    editor-type="dxNumberBox"
                    :editor-options="numberBoxOptions"
                />
                <DxItem 
                    data-field="Name" 
                    editor-type="dxTextArea"
                    :editor-options="{ height: 50 }"
                />
                <DxItem 
                    data-field="Years" 
                    editor-type="dxNumberBox"
                    :editor-options="numberBoxOptions"
                />
                <DxItem 
                    data-field="Months" 
                    editor-type="dxNumberBox"
                    :editor-options="numberBoxOptionsMonths"
                />
                <DxItem 
                    data-field="AttributeValue" 
                    editor-type="dxNumberBox"
                    :editor-options="numberBoxOptions"
                />
                <DxItem 
                    data-field="FreeDays" 
                    :col-span="2" 
                    editor-type="dxNumberBox"
                    :editor-options="numberBoxOptions"
                />
            </DxFormGrid>
        </DxEditing>
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Treaptă de Vechime
            </div>
        </template>

        <DxColumn data-field="Code" caption="Cod"/>
        <DxColumn data-field="Order" caption="Order"/>
        <DxColumn data-field="Name" caption="Nume"/>
        <DxColumn data-field="Years" caption="Ani"/>
        <DxColumn data-field="Months" caption="Luni"/>
        <DxColumn data-field="AttributeCode" caption="Cod Atribut"/>
        <DxColumn data-field="AttributeValue" caption="Valoare Atribut"/>
        <DxColumn data-field="FreeDays" caption="Zile Libere"/>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" width="500" height="465">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Treaptă de Vechime
            </div>
        </template>
        <DxForm :col-count="2" :data-dource="newTreaptaDeVechime">
            <DxSimpleItem data-field="Cod">
                <template #default>
                    <DxTextArea :value="newTreaptaDeVechime.Code" @value-changed="onCodValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Order">
                <template #default>
                    <DxNumberBox :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" :value="newTreaptaDeVechime.Order" @value-changed="onOrderValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newTreaptaDeVechime.Name" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Ani">
                <template #default>
                    <DxNumberBox :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" :value="newTreaptaDeVechime.Years" @value-changed="onYearsValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Luni">
                <template #default>
                    <DxNumberBox :min="1" :step="1" :max="11" :show-spin-buttons="true" :show-clear-button="true" :value="newTreaptaDeVechime.Months" @value-changed="onMonthsValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Valoare Atribut">
                <template #default>
                    <DxNumberBox :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" :value="newTreaptaDeVechime.AttributeValue" @value-changed="onAttributeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Zile Libere" :col-span="2">
                <template #default>
                    <DxNumberBox :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" :value="newTreaptaDeVechime.FreeDays" @value-changed="onFreeDaysValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
    import {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxPopup,
        DxItem,
        DxItem as DxFormItem,
        DxForm as DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxSearchPanel,
    } from 'devextreme-vue/data-grid';
    import DxDateBox from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import DxTextArea from 'devextreme-vue/text-area';
    import AppSetting from '@/settings/appSettings';
    import { defineComponent, ref } from 'vue';
    import DataSource from 'devextreme/data/data_source';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxForm, DxSimpleItem } from "devextreme-vue/form"
    import DxPopupAdd from 'devextreme-vue/popup'
    import { DxToolbarItem } from 'devextreme-vue/popup';
    import { DxNumberBox } from 'devextreme-vue';
    import PER_EmpJobsHistoryBenefits from '@/services/PER/PER_EmpJobsHistoryBenefits';

    export default defineComponent({
        components: {
            DxColumn,
            DxDataGrid,
            DxFilterRow,
            DxLoadPanel,
            DxPaging,
            DxSelection,
            DxSorting,
            DxStateStoring,
            DxToolbar,
            DxEditing,
            DxValidationRule,
            DxRequiredRule,
            DxItem,
            DxButton,
            DxSearchPanel,
            DxForm,
            DxPopupAdd,
            DxSimpleItem,
            DxTextArea,
            DxCheckBox,
            DxToolbarItem,
            DxPopup,
            DxFormGrid,
            DxFormItem,
            DxDateBox,
            DxNumberBox
        },
        data() {
            return {
                dsTrepteVechime: {} as DataSource,
                dataGridRef: ref<DxDataGrid | null>(null),
                deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
                addPopupVisible: false,
                newTreaptaDeVechime: {
                    Order: null,
                    Code: '',
                    Name: '',
                    Years: null,
                    Months: null,
                    AttributeValue: 0,
                    FreeDays: null,
                },
                addButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveAdd()
                    }
                },
                saveButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveEdit()
                    }
                },
                closeButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onCloseAdd()
                    }
                },
                dangerButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.closeEditPopup()
                    }
                },
                numberBoxOptions: {
                    min: 0,
                    step: 1,
                    showSpinButtons: true,
                    showClearButton: true,
                    height: 50
                },
                numberBoxOptionsMonths: {
                    min: 0,
                    max: 11,
                    step: 1,
                    showSpinButtons: true,
                    showClearButton: true,
                    height: 50
                },
            }
        },
        mounted() {
            this.dsTrepteVechime = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `PER_EmpJobsHistoryBenefits`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            })
            this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
            this.setDeleteConfirmationMessage()
        },
        methods: {
            setDeleteConfirmationMessage() {
                const dataGrid = this.$refs.dataGridRef?.instance;
                dataGrid.option('editing', {
                    allowUpdating: true,
                    allowDeleting: true,
                    mode: 'popup',
                    texts: {
                        confirmDeleteMessage: this.deleteConfirmationMessage,
                        confirmDeleteTitle: "Confirmare Ștergere",
                    }
                });
            },
            onRefreshClick() {
                const gridInstance = this.dataGridRef?.instance;
                if (gridInstance) {
                    gridInstance.refresh();
                    notify("Datele au fost actualizate cu succes!", "success", 3000);
                }
            },
            async onAddClick() {
                try {
                    const nextOrder = await this.calculateNextOrder();
                    this.newTreaptaDeVechime.Order = nextOrder;
                } catch (error) {
                    console.error("Could not calculate next order", error);
                    this.newTreaptaDeVechime.Order = 1;
                }

                this.addPopupVisible = true
            },
            closeEditPopup() {
                this.dataGridRef?.instance?.cancelEditData();
            },
            async onSaveEdit() {
                const gridInstance = this.dataGridRef?.instance;
                if (!gridInstance) {
                    notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                    return; 
                }
                try {
                    gridInstance.saveEditData()
                    notify('Datele au fost salvate cu succes!', 'success', 2000);
                } catch (error: any) {
                    console.error("Eroare la salvarea editării:", error);
                }
            },
            onCodValueChanged(e: any) {
                this.newTreaptaDeVechime.Code = e.value
            },
            onOrderValueChanged(e: any) {
                this.newTreaptaDeVechime.Order = e.value
            },
            onNumeValueChanged(e: any) {
                this.newTreaptaDeVechime.Name = e.value
            },
            onYearsValueChanged(e: any) {
                this.newTreaptaDeVechime.Years = e.value
            },
            onMonthsValueChanged(e: any) {
                this.newTreaptaDeVechime.Months = e.value
            },
            onAttributeValueChanged(e: any) {
                this.newTreaptaDeVechime.AttributeValue = e.value
            },
            onFreeDaysValueChanged(e: any) {
                this.newTreaptaDeVechime.FreeDays = e.value
            },
            onCloseAdd() {
                this.addPopupVisible = false
                this.newTreaptaDeVechime = {
                    Order: null, 
                    Code: '',
                    Name: '',
                    Years: null,
                    Months: null,
                    AttributeValue: null,
                    FreeDays: null,
                }
            },
            async calculateNextOrder() {
                const store = this.dsTrepteVechime.store();
                const result = await store.load({
                    sort: [{ selector: "Order", desc: true }],
                    take: 1
                });

                if (result && result.length > 0 && result[0].Order !== undefined) {
                    return result[0].Order + 1;
                }

                return 1;
            },
            onSaveAdd() {
                if (!this.newTreaptaDeVechime.Code || this.newTreaptaDeVechime.Code.trim() === "") {
                    notify("Vă rog să completați câmpul obligatoriu 'Cod'!", "error", 3000)
                    return
                }

                if (!this.newTreaptaDeVechime.Name || this.newTreaptaDeVechime.Name.trim() === "") {
                    notify("Vă rog să completați câmpul obligatoriu 'Nume'!", "error", 3000)
                    return
                }

                if (!this.newTreaptaDeVechime.Years) {
                    notify("Vă rog să completați câmpul obligatoriu 'Ani'!", "error", 3000)
                    return
                }

                if (!this.newTreaptaDeVechime.FreeDays) {
                    notify("Vă rog să completați câmpul obligatoriu 'Zile Libere'!", "error", 3000)
                    return
                }

                PER_EmpJobsHistoryBenefits.save(this.newTreaptaDeVechime).then((treapta) => {
                    this.addPopupVisible = false
                    notify('Datele au fost salvate cu succes!', 'success', 2000)
                    this.newTreaptaDeVechime = {
                        Order: null, 
                        Code: '',
                        Name: '',
                        Years: null,
                        Months: null,
                        AttributeValue: null,
                        FreeDays: null,
                    }
                    this.onRefreshClick()
                }).catch((error) => {
                    console.error(error)
                }) 
            }
        }
    })
</script>